var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinoAlerta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    },
    d: "M0 0h20v20H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10.366V8.75H15v1.875c0 .166.066.325.183.442l1.692 1.692v.991H3.125v-.991l1.692-1.692A.625.625 0 005 10.625v-2.5a4.99 4.99 0 017.5-4.323V2.404a6.184 6.184 0 00-1.875-.497V.625h-1.25v1.282A6.258 6.258 0 003.75 8.125v2.241l-1.692 1.692a.625.625 0 00-.183.442v1.875A.625.625 0 002.5 15h4.375v.625a3.125 3.125 0 106.25 0V15H17.5a.624.624 0 00.625-.625V12.5a.625.625 0 00-.183-.442l-1.692-1.692zm-4.375 5.259a1.875 1.875 0 11-3.75 0V15h3.75v.625z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 7.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    fill: "#45464F"
  })));
}
export default SvgSinoAlerta;